module.exports = __webpack_public_path__ + "static/media/donation.1ba2b565.jpg";